import * as moment from "moment";
import $ from "jquery";
import _ from 'lodash';

export default {
  //
  solicgeral: null, 
  pacsTabWindow: null,

  pacs_open_window(url) {
    if (!this.pacsTabWindow || this.pacsTabWindow.closed) {
      console.log('abrindo nova janela');
      this.pacsTabWindow = window.open(url, '_blank');
    } else {
      console.log('atualizando janela');
      this.pacsTabWindow.location.href = url;
      this.pacsTabWindow.focus();
    }
  },

  pacs_verifica_window_opened() {
    return this.pacsTabWindow && !this.pacsTabWindow.closed;
  },

  pacs_open_window_default(query = null) {
    if (this.pacsTabWindow) {
      console.log('atualizando janela default');
      let href = 'https://api-externa.klingo.app/pacs' ;
      if(query) {
        href += '?' + query;
      }
      this.pacsTabWindow.location.href = href;
    }
  },

  pacs_clear_window() {
    console.log('destruindo janela');

    if (this.pacsTabWindow) {
      this.pacsTabWindow = null;
    }
  },

  registrar_solic_geral(ref) { 
    this.solicgeral = ref;
  },
  get_solic_geral() { 
    return this.solicgeral;
  },
  //
  exibir_todos_avisos() { 
    this.ref_avisos.carregar();
  },
  exibir_avisos(avisos) { 
    this.ref_avisos.abrir(avisos);
  },
  exibir_aviso(id_aviso) { 
    this.ref_avisos.carregar(id_aviso);
  },
  registrar_ref_avisos(ref) { 
    this.ref_avisos = ref;  
  },
  ref_sncr: null,
  registrar_ref_sncr(ref) {
    this.ref_sncr = ref;
  },
  abrir_sncr() {
    if (this.ref_sncr) this.ref_sncr.abrir();
  },
  ref_avisos: null, 
  imprimir: { 
    func: null,
  },
  getregex(search){ 
    let pesquisar = search.trim();
    let match;
    let negacao = false; 

    if ( pesquisar && pesquisar.substr(0,1) == '-' ) {
        negacao = true;
        pesquisar = pesquisar.slice(1);
    }

    if ( pesquisar && pesquisar.substr(0,1) == '"' && pesquisar.substr(-1,1) == '"' ) {
      match = pesquisar; 
    } else { 
      pesquisar = pesquisar.replace(/\s{2,}/g, ' ');
      pesquisar = pesquisar.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[]\\\/]/gi, '');
      let parts = pesquisar.replaceAll(' ','.*');
      match = parts;
    }

    if (negacao) {
      match = '^(?!.*' + match + ').*'; // '(?!' + match + ')';
      console.log('negacao', match);
    }

    return new RegExp(match, 'i');
  },
  set_print_modal_function(func) { 
    this.imprimir.func = func;
  },
  print_preview(link, pep = false, dados = null, querystring = false) { 
    this.imprimir.func(link, pep, dados, querystring);
  },
  agora() {
    return moment().format("HH:mm:ss");
  },

  hoje() {
    return moment().format("YYYY-MM-DD");
  },

  hoje_com_hora(formato = "YYYY-MM-DD HH:mm") { 
    return moment().format(formato);
  },

  getDataDias(dias, format = "YYYY-MM-DD") {
    return moment().add(dias, 'days').format(format);
  },

  ultimo_dia_mes(date) { 
    return moment(date.substr(0,10), 'YYYY-MM-DD').clone().endOf('month').format('YYYY-MM-DD');
  },

  getFormatDate(date, format = "DD/MM/YYYY", exibirDataInvalida = true) {
    const data = moment(date, "YYYY-MM-DD");
    return data.isValid() 
      ? data.format(format) 
      : exibirDataInvalida 
        ? 'Data inválida' 
        : '';
  },

  getHumanDuration(date) {
    if (date.substr(0, 10) == this.hoje()) { 
        return "hoje";
    } else { 
        return moment
            .duration(moment(date, "YYYY-MM-DD").diff(this.hoje()))
            .humanize(true);
    }
  },

  tratar_valor(valor) { 

    if ( !valor ) { 
        return valor;
    }

    if ( isNaN(valor) ) { 
        if ( typeof valor == 'string' ) {
            if ( valor.indexOf(',') >= 0 ) {
                valor = valor.replace('.', '').replace(',', '.');
            }
        }

        valor = parseFloat(valor);
    }

    return valor;

  },

  formatMoeda(n, dec = 2, mindec = null) {
    if (n === null || n === undefined) n = 0;
    let formatter = new Intl.NumberFormat("pt-Br", {
      style: "currency",
      currency: "BRL",
      currencyDisplay: "code",
      minimumFractionDigits: ( mindec === null ? dec : mindec ), 
      maximumFractionDigits: dec, 
    });

    if ( Math.round(n * Math.pow(10, dec)) < 0 ) 
      return '(' + formatter.format(n * -1).replace("BRL", "").trim() + ')';
    else
      return formatter.format(parseFloat(n)).replace("BRL", "").trim();
  },

  formatNumber(n, prec) {
    if ( prec == 0 ) { 
      return Math.round(n);
    }

    let formatter = new Intl.NumberFormat("pt-Br", {
      style: "decimal",
      minimumFractionDigits: prec,
      maximumFractionDigits: prec
    });

    return formatter.format(n);
  },

  formatMask(texto, mask) {
    if (!texto) return texto;

    if (typeof texto == "number") texto = texto.toString();

    let masked;
    switch (mask) {
      case "cnpj":
        texto = texto.toUpperCase().replace(/[^A-Z0-9]/g, "");

        masked = texto.replace(
            /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
            "$1.$2.$3/$4-$5"
        );
        break;

      case "cpf":
        masked = texto.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        break;

     case "cpf-cnpj":
        texto = texto.toUpperCase().replace(/[^A-Z0-9]/g, "");

        if (texto.length === 11) {
            masked = texto.replace(
                /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
                "$1.$2.$3-$4"
            );
        } else if (texto.length === 14) {
            masked = texto.replace(
                /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
                "$1.$2.$3/$4-$5"
            );
        } else {
            masked = texto;
        }

        break;

      case "tuss":
        masked = texto.replace(/^(\d{1})(\d{2})(\d{2})(\d{3})/, "$1.$2.$3.$4");
        break;

      case "cep":
        masked = texto.replace(/^(\d{5})(\d{3})/, "$1-$2");
        break;

      case "tel":
        masked = ( texto && texto.length == 11 ) 
          ? texto.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
          : texto.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
        break;

      case "cel":
        masked = texto.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
        break;

      default:
        masked = texto;
        break;
    }
    return masked;
  },

  siglaUF(codigoUF){
    let sigla;
    switch(codigoUF){
      
      case "11":
        sigla = "RO";
        break;
      
      case "12":
        sigla = "AC";
        break;

      case "13":
        sigla = "AM";
        break;

      case "14":
        sigla = "RR";
        break;

      case "15":
        sigla = "PA";
        break;
      case "16":
        sigla = "AP";
        break;
    
      case "17":
        sigla = "TO";
        break;
      
      case "21":
        sigla = "MA";
        break;
    
      case "22":
        sigla = "PI";
        break;
    
      case "23":
        sigla = "CE";
        break;
    
      case "24":
        sigla = "RN";
        break;
  
      case "25":
        sigla = "PB";
        break;
    
      case "26":
        sigla = "PE";
        break;
    
      case "27":
        sigla = "AL";
        break;
    
      case "28":
        sigla = "SE";
        break;
    
      case "29":
        sigla = "BA";
        break;

      case "31":
        sigla = "MG";
        break;
    
      case "32":
        sigla = "ES";
        break;
     
      case "33":
        sigla = "RJ";
        break;
     
      case "35":
        sigla = "SP";
        break;

      case "41":
        sigla = "PR";
        break;
     
      case "42":
        sigla = "SC";
        break;
     
      case "43":
        sigla = "RS";
        break;

      case "50":
        sigla = "MS";
        break;
      
      case "51":
        sigla = "MT";
        break;
      
      case "52":
        sigla = "GO";
        break;
      
      case "53":
        sigla = "DF";
        break;

      default:
        sigla = codigoUF
        break;
    }
    return sigla
  },

  gerarRandomString(lenght, inicial = "" ) {
    let newId = inicial;
    for (let i = 0; i < lenght; i++) {
      let rand = Math.floor(Math.random() * 62);
      var charCode = (rand += rand > 9 ? (rand < 36 ? 55 : 61) : 48);

      newId += String.fromCharCode(charCode);
    }
    return newId;
  },

  tem_internacao () { 
    if ( window.app.$store.state.user.id_usuario == 1 ) { 
        return true; 
    } else if ( window.app.$store.state.user && window.app.$store.state.user.perfil_usuarios ) { 
        return window.app.$store.state.user.perfil_usuarios.some( p => p.id_perfil == 19 );
    }
    return false;
  },

  // Links de abertura

  abrirPagamentos(marcacao, id_pagamento_atendimento = null) { 
    if ( !marcacao.id_paciente )
      return;

    $(".modal").modal("hide");

    window.app.$router.push({ name: 'pagamentos', params: { idpaciente: marcacao.id_paciente, id_pagamento_atendimento: id_pagamento_atendimento } });

    //'/recepcao/pagamentos/' + marcacao.id_paciente
  },

  abrirFatura(id_fatura) {
    $(".modal").modal("hide");

    window.app.$router.push({
      name: "faturas",
      params: {
        id_fatura: id_fatura,
        link: true
      }
    });
  },

  abrirMedico(medico) {
    $(".modal").modal("hide");

    window.app.$router.push({
      name: "c-prestadores",
      params: {
        id_medico: medico.id_pessoa,
        link: true
      }
    });
  },

  abrirUsuario(usuario) {
    $(".modal").modal("hide");
    $('[data-toggle="tooltip"]').tooltip("dispose");

    window.app.$router.push({
      name: "c-usuarios",
      params: {
        id_usuario: usuario.id_usuario,
        link: true
      }
    });
  },

  abrirProcedimento(procedimento) {
    $(".modal").modal("hide");

    window.app.$router.push({
      name: "c-procedimentos",
      params: {
        id_procedimento: procedimento.id_procedimento,
        link: true
      }
    });
  },

  abrirOperadora(operadora, submenu = "") {
    $(".modal").modal("hide");

    window.app.$router.push({
      name: "c-operadoras",
      params: {
        id_operadora: operadora.id_operadora,
        go_submenu: submenu,
        link: true
      }
    });
  },

  abrirTabela(tabela) {
    $(".modal").modal("hide");
    $('[data-toggle="tooltip"]').tooltip("dispose");

    let filtro_item = {};

    if (
      tabela.procedimento_item_tabela &&
      tabela.procedimento_item_tabela.item_tabela
    ) {
      filtro_item = {
        id_item_tabela:
          tabela.procedimento_item_tabela.item_tabela.id_item_tabela
      };
    }

    window.app.$router.push({
      name: "c-tabelas",
      params: {
        id_tabela_versao: tabela.id_tabela_versao,
        ...filtro_item,
        link: true
      }
    });
  },

  /*
  marcar_revisao(marcacao) { 
    $(".modal").modal("hide");
    $('[data-toggle="tooltip"]').tooltip("dispose");

    if ( window.app.$route.path == '/call-center') { 
        window.app.$router.push({ path: '/' })
          .then(() => { 
            window.app.$router.push({
              name: "call-center",
              params: {
                remarcacao: marcacao.id_marcacao,
                trocarmedico: trocarMedico
              },
              trocarmedico: trocarMedico
            });
          });
    } else { 
      window.app.$router.push({
        name: "call-center",
        params: {
          remarcacao: marcacao.id_marcacao,
          trocarmedico: trocarMedico
        },
        trocarmedico: trocarMedico
      });
    }
  },
  */

  remarcar(marcacao, trocarMedico = false, outros_parms = null) {
    $(".modal").modal("hide");
    $('[data-toggle="tooltip"]').tooltip("dispose");

    window.app.$root.remarcar(marcacao.id_marcacao, trocarMedico, outros_parms);
  },

  tratar_num_lote (num_lote) {
    if ( num_lote && num_lote.includes('|') ) { 
        return num_lote.split('|')[0];
    }

    return num_lote; 
  },

  // Métodos de interação com o Backend.

  remover(ref, options) {
    ref.$store.commit("loading", true);

    let query = {
      q: [
        {
          name: options.service + ".destroy",
          id: "destroy",
          parms: {
            ...options.dados
          }
        }
      ]
    };

    ref.axios
      .post("/aql", query)
      .then(res => {
        if (res.data.destroy.status == 200) {
          if (options.reload) ref.load();

          if (options.modal) $("#" + options.modal).modal("hide");

          if (options.callback) {
            options.callback();
          }
        }
      })
      .finally(() => {
        ref.$store.commit("loading", false);
      });
  },

  valid_permissao (ref, id, callback = null) { 
    ref.$util.loadItem(ref, { 
      service: 'usuarios',
      func: 'tem_permissao_acesso', 
      parms: { 
        resource_id: id, 
      },
    })
    .then(res => { 
      if ( res && res.pode === false ) { 
        ref.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: 'Acesso negado. (#' + id + ')',
          life: 10000
        });

        setTimeout(() => {
          ref.$router.push({ name: "dashboard" });
        }, 3000);
      } else { 

        if ( callback ) { 
          callback();
        }

      }
    });
  },

  abrir_atendimento(ref, id) { 
    //console.log(ref.$router.currentRoute.name);
    //console.log(ref.$router);

    if ( ref.$router.currentRoute.name == 'recepcao' ) {
      ref.$router.push({ name: "dashboard" });

      ref.$nextTick(() => {
        ref.$router.push({ name: 'recepcao', params: { id_atendimento: id } });
      });
    } else { 
      ref.$router.push({ name: 'recepcao', params: { id_atendimento: id } });
    }
  },

  abrir_solicitacao(ref, id) { 
    ref.$router.push({ name: 'suprimentos', params: { aba: 'atendimento', search: id } });
  },
  
  toggle(ref, options) {
    ref.$store.commit("loading", true);

    let query = {
      q: [
        {
          name: options.service + ".toggle",
          id: "toggle",
          parms: {
            ...options.dados
          }
        }
      ]
    };

    ref.axios
      .post("/aql", query)
      .then(res => {
        if (res.data.toggle.status == 200) {
          if (options.callback) {
            options.callback(res.data.toggle);
          }
        }
      })
      .finally(() => {
        ref.$store.commit("loading", false);
      });
  },

  atualizar(ref, options) {
    $('[data-toggle="tooltip"]').tooltip("dispose");

    if ( options && options.no_validate ) { 
      ref.validate = false; 
    } else { 
      ref.validate = true;
    }

    ref.$nextTick(() => {

      let invalids = $( ( options.modal ? '#' + options.modal + ' ' : '' ) + ".invalid");

      if (invalids.length && $(".invalid").is(":visible") && !( options && options.no_validate )) {
        ref.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Verificar preenchimento dos campos.",
          life: 3000
        });

        if ( options.final )
          options.final();

      } else {
        ref.$store.commit("loading", true);

        let query = {
          q: [
            {
              name:
                options.service +
                (options.func ? "." + options.func : ".store"),
              id: "atualizar",
              parms: {
                ...options.dados
              }
            }
          ]
        };

        let info = options.service + (options.func ? "." + options.func : ".store");
        let continue_loading = false;

        const base = ref.axios.defaults.baseURL;
        const redir = ( options.redir_api && base.substr(0,5) == 'https' )
          ? 'https://api-relatorio.klingo.app/api' 
          : '';

        ref.axios
          .post(redir + "/aql?a=" + info, query)
          .then(res => {
            if (res && res.data && ( res.data.atualizar.status == 200 || res.data.atualizar.status == 290 ) ) {
                
              if (options.reload) { 
                continue_loading = true;
                ref.load();
              }

              if (options.modal) $("#" + options.modal).modal("hide");

              if (options.callback) {
                options.callback(res.data.atualizar.data);
              }

              if (options.toast && options.toast !== false) {
                ref.$toast.add({
                  severity: "success",
                  summary: "Atualizar",
                  detail: options.msg ? options.msg : "Atualização realizada.",
                  life: 3000
                });
              }
            } else { 
              options.continue_loading = false;

              console.log('Er', res);

              if ( res && res.data && res.data.atualizar.status >= 400 ) { 
                console.log('2', options);
                if (options.error) {
                  options.error(res.data.atualizar.data);
                }    

                if ( options.callback_error ) { 
                    options.callback_error(res.data.atualizar);
                }
              }

            }

            if (res && res.data && res.data.atualizar.status == 409) {
              if ( options.conflict_reload )
                options.conflict_reload();
            }

          })
          .catch(res => { 
            if (options.error) {
              options.error(res);
            }
          })
          .finally(() => {
            if ( !options.continue_loading && !continue_loading )
              ref.$store.commit("loading", false);
              
            if ( options.final )
              options.final();
          });
      }
    });
  },

  resync(ref, service) { 
    let options = ref.$store.state.options;

    if ( options[service] ) { 
      options[service] = undefined;
      ref.$store.commit('setOptions', options);
    }
  },

  load(ref, options) {
    ref.$store.commit("loading", true);

    let query = {
      q: [
        {
          name: options.service + (options.func ? "." + options.func : ".index"),
          id: "lista",
          with: options.with,
          parms: {
            ...options.parms,
            with: options.with,
          },
          configs: options.configs
        }
      ],
      page: options.page,
      size: options.size 
    };

    let info = options.service + (options.func ? "." + options.func : ".index");

    if ( options && options.page && !isNaN(options.page) ) { 
      info += '&page=' + options.page;
    }

    const base = ref.axios.defaults.baseURL;
    const redir = ( options.redir_api && base.substr(0,5) == 'https' )
      ? 'https://api-relatorio.klingo.app/api' 
      : '';
    
    ref.axios
      .post(redir + "/aql?a=" + info, query, {
          cancelToken: options.canceltoken,
      })
      .then(res => {
        if ( !res || !res.data ) { 
          return; 
        }

        if (res.data.lista.status == 200) {

            let pagina = options.page
                ? options.page
                : (options.parms ? options.parms.page : 1);

          if ( options.reload_page && pagina && pagina > 1 && pagina > res.data.lista.data.last_page ) { 
            ref.load(1);
            return;
          }

          if ( options.configs && res.data.configs_lista ) { 
            ref.$store.commit('setContexto', res.data.configs_lista);
          }
          
          if (options.loadTo) {
            options.loadTo(res.data.lista.data);
          } else {
            ref.dados = res.data.lista.data;
          }

        }
      })
      .finally(() => {
        ref.$store.commit("loading", false);

        if ( options.final )
          options.final();
      });
  },

  loadItem(ref, options) {
    let query = {
      q: [
        {
          name: options.service + (options.func ? "." + options.func : ".show"),
          id: "item",
          with: options.with,
          parms: {
            with: options.with,
            id: options.id,
            ...options.parms
          },
          configs: options.configs
        }
      ]
    };

    let info = options.service + (options.func ? "." + options.func : ".show");

    return ref.axios.post("/aql?a=" + info + ( options.id ? ( '&i=' + options.id ) : '' ), query).then(res => {
      if (res.data.item.status == 200) {

        if ( options.configs && res.data.configs_item ) { 
          ref.$store.commit('setContexto', res.data.configs_item);
        }

        return res.data.item.data;
        
      }
    });
  },

  acesso() {
    let query = {
      q: [
        {
          name: "modulos.acesso",
          id: "acesso"
        }
      ]
    };

    this.axios.post("/aql", query).then(res => {
      if (res.data.acesso.status == 200) {
        return res;
      }
    });
  },

  logAudit(model, id, parms = null) {
    $(".modal").modal("hide");

    window.app.$router.push({
      name: "audits",
      params: { model: model, id: id, parms: parms }
    });
  },

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        let cvalue = c.substring(name.length, c.length);

        if ( cvalue == 'null' || cvalue == 'undefined' ) { 
          cvalue = "";
        }

        return cvalue;
      }
    }
    return "";
  },

  setCookie(cname, cvalue, exdays = 365) {
    if ( !cvalue || cvalue == 'null' || cvalue == 'undefined' ) { 
      cvalue = "";
    }

    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();

    if ( cvalue === "" ) { 
        expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
    }

    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },

  check_perfil(user, perfil, path) { 

    if ( perfil && user ) { 
      if ( user.perfil_usuarios.find(item => { 
        return item.id_perfil == perfil || item.id_perfil == 2;
      })) { 
        //
      } else { 
        console.log("Acesso negado a " + path);
        return false;
      }
    } 

    return true;

  },

  tem_sus() { 
    if ( window.app.$store.state.unidade &&
      window.app.$store.state.unidade.parametro_unidade &&
      window.app.$store.state.unidade.parametro_unidade.fl_sus ) {
        return true;
    } else { 
      return false;
    }
  },

  nl2br (str, is_xhtml = false) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }

    if ( /<\/?[a-z][\s\S]*>/i.test(str) ) { 
      return str;
    }

    str = str.replace(/[\u00A0-\u9999<>]/gim, function(i) {
      return '&#' + i.charCodeAt(0) + ';';
    });

    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  },

  acesso_a_config () { 
    return window.app.$store.state.user.id_usuario == 1 || window.app.$store.state.user.perfil_usuarios.findIndex(item => item.id_perfil == 6) >= 0;
  },

  somar(lista, campo) { 
    return _.sumBy(lista, campo);
  },

  validarcpf(cpf) {
    if (cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999")
        return false;

    let add = 0;
    let i;

    for (i = 0; i < 9; i++)
            add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
        rev = 0;
    if (rev != parseInt(cpf.charAt(9)))
        return false;
    add = 0;
            for (i = 0; i < 10; i++)
            add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
        rev = 0;
    if (rev != parseInt(cpf.charAt(10)))
        return false;
    return true;
},

validarcnpj(cnpj) {
    cnpj = cnpj
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');

    if (cnpj.length !== 14)
        return false;

    // Os 12 primeiros podem ser letras ou números.
    // Os 2 últimos devem ser dígitos.
    if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj))
        return false;

    const base = cnpj.substring(0, 12);

    const dv1 = this.calcularDvCnpj(base);
    const dv2 = this.calcularDvCnpj(base + dv1);

    return cnpj === base + dv1 + dv2;
},

valorCnpj(caractere) {

    if (/\d/.test(caractere))
        return parseInt(caractere, 10);

    // Regra do Serpro: valor = ASCII - 48
    return caractere.charCodeAt(0) - 48;
},

calcularDvCnpj(valor) {

    const pesos = valor.length === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    let soma = 0;

    for (let i = 0; i < valor.length; i++) {
        soma += this.valorCnpj(valor[i]) * pesos[i];
    }

    const resto = soma % 11;

    return resto <= 1 ? 0 : 11 - resto;
},

filtro_2_periodo(filtro) { 

  let lista = {    
    m: 'Mês Atual',
    ma: 'Mês Anterior',
    a: 'Ano Atual',
    aa: 'Ano Anterior',
    h: 'Hoje',
    o: 'Ontem',
    do: 'Desde Ontem',
  }

  if ( lista[filtro.periodo] ) { 
    return lista[filtro.periodo];
  }

  switch (filtro.periodo) {
    case 'lm': return this.getFormatDate(filtro.mes).substr(3);
    case 's': return filtro.semana;
    case 'ld': return this.getFormatDate(filtro.inicio);
    case 'ms': return this.getFormatDate(filtro.mes_inicial).substr(3) + ' a ' + this.getFormatDate(filtro.mes_final).substr(3) ;
    default:
      return lista[filtro.periodo] 
        ? lista[filtro.periodo] 
        : this.getFormatDate(filtro.inicio) + ' a ' + this.getFormatDate(filtro.fim);
  }

},

periodo_2_datas(filtro) { 

  let datas = { 
    inicio: "",
    fim: ""
  };

  switch (filtro.periodo) {
    case 'm':   // Mês Atual
      datas.inicio = moment().startOf('month').format('YYYY-MM-DD');
      datas.fim = moment().endOf('month').format('YYYY-MM-DD');
      break;

    case 'ma':  // Mês Anterior
      datas.inicio = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      datas.fim = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      break;

    case 'do':  // Desde ontem
      datas.inicio = moment().subtract(1, 'days').format('YYYY-MM-DD');
      datas.fim = moment().format('YYYY-MM-DD');
      break;

    case 'o':   // Ontem
        datas.inicio = moment().subtract(1, 'days').format('YYYY-MM-DD');
        datas.fim = moment().subtract(1, 'days').format('YYYY-MM-DD');
        break;

    case 'h':   // Hoje
      datas.inicio = moment().format('YYYY-MM-DD');
      datas.fim = moment().format('YYYY-MM-DD');
      break;

    case 'a':   // Ano Atual
      datas.inicio = moment().startOf('year').format('YYYY-MM-DD');
      datas.fim = moment().endOf('year').format('YYYY-MM-DD');
      break;

    case 'aa':  // Ano Anterior
      datas.inicio = moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD');
      datas.fim = moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD');
      break;

    case 'lm':
      datas.inicio = filtro.mes ? filtro.mes + '-01' : '';
      datas.fim = filtro.mes ? moment(datas.inicio).endOf('month').format('YYYY-MM-DD') : '';
      break;

    case 'ld':
      datas.inicio = filtro.inicio;
      datas.fim = filtro.inicio;
      break;
  
    default:    // Livre
      datas.inicio = filtro.inicio;
      datas.fim = filtro.fim;
      break;
  }

  return datas

  /*
  
  switch (filtro.periodo) {
    case 's': return filtro.semana;
    case 'ld': return this.getFormatDate(filtro.inicio);
    case 'ms': return this.getFormatDate(filtro.mes_inicial).substr(3) + ' a ' + this.getFormatDate(filtro.mes_final).substr(3) ;
    default:
      return lista[filtro.periodo] 
        ? lista[filtro.periodo] 
        : this.getFormatDate(filtro.inicio) + ' a ' + this.getFormatDate(filtro.fim);
  }
  */

},

unidades_usuario(acesso = false) { 
  if ( ( acesso && window.app.$store.state.user.fl_acesso_por_centro_custo )
      && window.app.$store.state.user.centros 
      && window.app.$store.state.user.centros.length ) { 

    return window.app.$store.state.user.centros.flatMap(centro => { 
        if ( centro && centro.centro ) { 
            return [centro.centro.unidade_operacao];
        }
        return [];
    });

  }

  return window.app.$store.state.unidade.unidade_operacaos;
},

centros_usuario(id_unidade_operacao, acesso = false) { 
  if ( !id_unidade_operacao )
    return [];

  if ( ( acesso && window.app.$store.state.user.fl_acesso_por_centro_custo )
      && window.app.$store.state.user.centros 
      && window.app.$store.state.user.centros.length ) { 

    return window.app.$store.state.user.centros.filter(centro => centro.centro.id_unidade_operacao == id_unidade_operacao)
      .map(centro => centro.centro);

  }

  let und = window.app.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == id_unidade_operacao);

  return und ? und.centro_custos : [];
},

unidade_operacao(id = null) { 

  const id_uo = id 
    ? id 
    : ( window.app.$store.state.unidade.unidade_operacaos.length == 1 
        ? window.app.$store.state.unidade.unidade_operacaos[0].id_unidade_operacao
        : window.app.$util.getCookie('id_unidade_operacao') );
  
  if ( !id_uo || isNaN(id_uo) ) { 
    return "";
  }

  return window.app.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == id_uo);

},

recepcao () { 

  const uo = this.unidade_operacao();

  if ( !uo )
    return;

  const id_recep = window.app.$util.getCookie('id_recepcao');

  return ( uo.recepcaos.length == 1 
    ? uo.recepcaos[0]
    : uo.recepcaos.find(item => item.id_recepcao == id_recep) );

},

uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
},

unidades_com_tags(tags = true, acesso = false) { 
  let lista;

  if ( !acesso ) { 
    lista = _.cloneDeep(window.app.$store.state.unidade.unidade_operacaos);
  } else { 
    lista = _.cloneDeep(window.app.$util.unidades_usuario(true));
  }

  if ( tags ) { 
    window.app.$store.state.unidade.unidade_operacaos.forEach(element => {
      if ( element.js_classes ) { 
        element.js_classes.forEach(classe => { 
          lista.push({ 
            id_unidade_operacao: '#' + classe,
            st_nome: '#' + classe,
            search: '#' + classe,
          });
        });
      }
    });
  }

  return _.orderBy(
      _.uniqBy(lista, 'id_unidade_operacao'), 
      'search'
    );
}, 

copiar_clipboard (ref, text, mensagem = null) {
  if (!navigator.clipboard) {
      var textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position="fixed";  //avoid scrolling to bottom
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'successful' : 'unsuccessful';
          console.log('Fallback: Copying text command was ' + msg);
      } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
  } else {
      navigator.clipboard.writeText(text).then(function() {
          console.log('Async: Copying to clipboard was successful!');
      }, function(err) {
          console.error('Async: Could not copy text: ', err);
      });
  }

  ref.$toast.add({
      severity: "success",
      summary: "Atenção",
      detail: mensagem ? mensagem : "Código '" + text + "' copiado para a área de transferência.",
      life: 3000
  });
},

check_mobile_device() {
  let check = false;
  check = /Mobile|Android/.test(navigator.userAgent);
  //(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
},

ucwords (str) {

  if(!str) return '';
  return _.startCase(_.toLower(str));
  
},

calc_sup_corp (peso, altura) { 
  if ( !peso || !altura ) {
    return;
  }
  
  return Math.round(
      Math.sqrt(Number(altura * 100) * Number(peso) / 3600) * 100
  ) / 100;
},

valores(campos) {

  if ( !campos )
      return false;

  let valores = campos;

  valores = valores.flatMap(x => ( ( x.type == 'group' || x.type == 'tabela' ) && x.campos ) ? x.campos : x);
  valores = valores.flatMap(x => ( ( x.type == 'group' || x.type == 'tabela' ) && x.campos ) ? x.campos : x);
  valores = valores.flatMap(x => ( ( x.type == 'group' || x.type == 'tabela' ) && x.campos ) ? x.campos : x);

  return valores;

},

htmlToPaper(el, localOptions = null, cb = () => true) {
          
  const addStyles = (win, styles) => {
  styles.forEach(style => {
          let link = win.document.createElement('link');
          link.setAttribute('rel', 'stylesheet');
          link.setAttribute('type', 'text/css');
          link.setAttribute('href', style);
          win.document.getElementsByTagName('head')[0].appendChild(link);
      });
  }

  let defaultName = '_blank', 
      defaultSpecs = ['fullscreen=yes','titlebar=yes', 'scrollbars=no'],
      defaultReplace = true,
      defaultStyles = [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://kit-free.fontawesome.com/releases/latest/css/free.min.css"
      ];

  let options = {};

  let {
      name = defaultName,
      specs = defaultSpecs,
      replace = defaultReplace,
      styles = defaultStyles,
      autoClose = true
  } = options;

  if (localOptions) {
      if (localOptions.name) name = localOptions.name;
      if (localOptions.specs) specs = localOptions.specs;
      if (localOptions.replace) replace = localOptions.replace;
      if (localOptions.styles) styles = localOptions.styles;
      if (localOptions.autoClose === false) autoClose = localOptions.autoClose;
  }

  specs = specs.length ? specs.join(',') : '';

  const element = document.getElementById(el);

  if (!element) {
      alert(`Element to print #${el} not found!`);
      return;
  }
  
  const url = '';
  const win = window.open(url, name, specs, replace);

  win.document.write(`
      <html>
      <head>
          <title>${document.title}</title>
      </head>
      <body>
          ${element.innerHTML}
      </body>
      </html>
  `);

  addStyles(win, styles);
    
  setTimeout(() => {

      win.document.close();
      win.focus();
      win.print();

      if (autoClose && !this.check_mobile_device()) {
          setTimeout(function () {win.close();}, 1);
      }

      cb();
      
  }, 1000);
      
  return true;
},

convertFileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);

        reader.readAsDataURL(file);
    });
},

minutes2time(minutes) {
    // Converte para segundos
    const totalSeconds = Math.floor(minutes * 60);

    const hours = Math.floor(totalSeconds / 3600);
    const remainingSeconds = totalSeconds % 3600;

    const mins = Math.floor(remainingSeconds / 60);
    const secs = remainingSeconds % 60;

    // Formata com zero à esquerda
    const pad = (n) => String(n).padStart(2, '0');

    return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
},

is_usuario_delegado (id_medico) { 
    if ( window.app.$store.state.user.delegantes_medicos && window.app.$store.state.user.delegantes_medicos.length ) { 
        let teste = window.app.$store.state.user.delegantes_medicos.find(item => item.delegante && item.delegante.id_pessoa == id_medico);

        if ( teste ) { 
            return true; 
        }
    }

    return false; 
},

isValidPusherChannelName(channel) {
    if ( !channel) {
        return true;
    }

    if (typeof channel !== 'string') {
        return false;
    }

    if (channel.length === 0 || channel.length > 164) {
        return false;
    }

    // Caracteres permitidos pelo Pusher
    return /^[A-Za-z0-9_\-=@,.;]+$/.test(channel);

},

/**
 * Abre um PDF em nova aba.
 * Aceita:
 *   - data URI:  "data:application/pdf;base64,JVBERi0..."
 *   - base64 puro: "JVBERi0..."
 *   - URL http(s) ou blob: válida
 *
 * @param {string} dados  String contendo data URI, base64 ou URL
 * @returns {Window|null}  Referência da janela aberta (ou null em caso de erro)
 */
abrirPdf(dados) {
    if (!dados) {
        console.warn('[abrirPdf] Nenhum dado recebido.');
        return null;
    }

    return this._abrirPdfBase64(dados);
},

/**
 * Converte base64 em Blob e abre em nova aba.
 * @private
 */
_abrirPdfBase64(base64) {
    try {
        const bin = atob(base64);
        const bytes = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) {
            bytes[i] = bin.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        const win = window.open(blobUrl, '_blank');

        // Libera a memória após o carregamento (fallback de tempo)
        if (win) {
            win.addEventListener('load', () => URL.revokeObjectURL(blobUrl), { once: true });
        } else {
            // Popup bloqueado: libera imediatamente
            setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
        }

        return win;
    } catch (e) {
        console.error('[abrirPdf] Erro ao abrir base64:', e);
        return null;
    }
}

}
